export async function useFetch(endpoint: string, type = 'POST', data?: unknown) {
	try {
		const res = await fetch(endpoint, {
			method: type,
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(data),
		}).then((r) => r.json())
		return res
	} catch (error) {
		throw error
	}
}
